import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('client_phone_phone_index', ['phone'], {})
@Index('client_phone_pk', ['fkClientId', 'phone'], { unique: true })
@Entity('client_phone')
export class ClientPhoneEntity extends BaseEntity {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: 'phone', length: 64 })
	public phone!: string;

	@ManyToOne(() => ClientEntity, (client) => client.clientPhones, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
